// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The property inspector provider token.
 */
export const IPropertyInspectorProvider = new Token('@jupyterlab/property-inspector:IPropertyInspectorProvider', 'A service to registry new widget in the property inspector side panel.');
//# sourceMappingURL=token.js.map